import {AppConfig} from '@frontend/AppConfig'
import {useUserData} from '@frontend/hooks'
import type {NewChatMessageEventData} from '@frontend/modules/private/chats/ChatsModuleTypes'
import type {NewSupportTicketCommentEventData} from '@frontend/modules/private/support_tickets/SupportTicketsModuleTypes'
import {useAccountFlagsStore} from '@frontend/stores'
import {playMessageReceivedSoundIfNotPlaying} from '@shared/helpers/getMessageReceivedSound'
import {useMemo} from 'react'
import {WebSocketConnector} from 'swayok-react-mdb-ui-kit/components/WebSockets/WebSocketConnector'
import {WebSocketEventsHandler} from 'swayok-react-mdb-ui-kit/components/WebSockets/WebSocketEventsHandler'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import type {AnyObject} from 'swayok-react-mdb-ui-kit/types/Common'

// Обработчики событий, получаемых через WebSocket.
export function GlobalWebsocketHandlers() {

    const user = useUserData()
    const setHasNewChatMessages = useAccountFlagsStore(
        state => state.setHasNewChatMessages
    )
    const setHasNewSupportTicketReplies = useAccountFlagsStore(
        state => state.setHasNewSupportTicketReplies
    )

    // Каналы получения websocket сообщений.
    const websocketChannels: AnyObject<string> = useMemo(() => ({
        private: 'App.Models.User.' + (user?.id || '0'),
    }), [user?.id])

    // Событие: получено новое сообщение в чат.
    const newMessageReceived = useEventCallback((
        event: NewChatMessageEventData
    ) => {
        /*
         * console.log(
         *     `[WebSocketEventsHandler] ${WebsocketEvent.NewChatMessage}: `
         *     + JSON.stringify(event, null, '  ')
         * )
         */
        if (event.message.user.id !== user?.id) {
            /*
             * Сообщение от другого пользователя:
             * поставить флаг "есть непрочитанные сообщения".
             */
            setHasNewChatMessages(true)
            // Запуск звука нового сообщения, если он готов к новому проигрыванию.
            playMessageReceivedSoundIfNotPlaying()
        }
    })

    // Событие: получен новый комментарий к обращению в службу поддержки.
    const newSupportTicketComment = useEventCallback((
        event: NewSupportTicketCommentEventData
    ) => {
        if (!event.comment.isOwn) {
            /*
             * Сообщение модератора:
             * поставить флаг "есть непрочитанные сообщения".
             */
            setHasNewSupportTicketReplies(true)
            // Запуск звука нового сообщения, если он готов к новому проигрыванию.
            playMessageReceivedSoundIfNotPlaying()
        }
    })

    if (!user) {
        return null
    }

    return (
        <WebSocketConnector
            key={'websockets-' + user.id}
            userId={user.id}
            channels={websocketChannels}
        >
            <WebSocketEventsHandler<NewChatMessageEventData>
                key="global-new-chat-message"
                subscriptionId="global-new-chat-message"
                event={AppConfig.websocketEvent.newChatMessage}
                handler={newMessageReceived}
            />
            <WebSocketEventsHandler<NewSupportTicketCommentEventData>
                key="global-new-support-ticket-comment"
                subscriptionId="global-new-support-ticket-comment"
                event={AppConfig.websocketEvent.newSupportTicketComment}
                handler={newSupportTicketComment}
            />
        </WebSocketConnector>
    )
}
